let initialState = {
  isSidebarExpanded: false,
  language: null,
  version: require('../../../package.json').version
}

export default {
  state: () => initialState,
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.isSidebarExpanded = !state.isSidebarExpanded
    },
    SET_LANGUAGE(state, language) {
      state.language = language
    },
  },
  actions: {
    async resetApp({ dispatch }, force = false) {
      await Promise.all([
        dispatch('resetVoucher', null, { root: true }),
        dispatch('resetCoverSheets', null, { root: true }),
        dispatch('resetAccount', null, { root: true }),
        dispatch('resetCredit', null, { root: true }),
        dispatch('resetEntry', null, { root: true }),
        dispatch('resetErrors', null, { root: true }),
        dispatch('resetWhitelabel', null, { root: true }),
        dispatch('resetTheme', null, { root: true }),
        dispatch('resetSettings', null, { root: true }),
        dispatch('resetUserProfile', null, { root: true }),
        dispatch('resetPermissions', null, { root: true }),
        dispatch('resetOrganizations', null, { root: true }),
        dispatch('resetNotifications', null, { root: true }),
        dispatch('resetModals', null, { root: true }),
        dispatch('resetInboxes', null, { root: true }),
      ]);

      localStorage.clear();
      sessionStorage.clear();

      if (force) {
        location.reload();
      }
    }
  },
  getters: {
    isSidebarExpanded: state => {
      return state.isSidebarExpanded
    },
    language: state => {
      return state.language
    },
    appVersion: state => {
      return state.version
    }
  }
}
